import { render, staticRenderFns } from "./ChipPrimary.vue?vue&type=template&id=573557f0&scoped=true"
import script from "./ChipPrimary.vue?vue&type=script&lang=js"
export * from "./ChipPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573557f0",
  null
  
)

export default component.exports